export default "__VITE_ASSET__ad05b149__"